<template>
  <div class="blog-posts-highlighted-section">
    <div class="blog-posts-highlighted-section__inner">
      <div class="saas-striped-title">Keep on reading</div>

      <div class="blog-posts-highlighted-section__items">
        <BlogPostCard
          v-for="post in posts"
          :key="post.id"
          class="blog-posts-highlighted-section__item"
          :post="post"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BlogPostCard from '@saas/components/blog/BlogPostCard.vue'

export default {
  name: 'BlogPostsHighlightedSection',
  components: { BlogPostCard },
  computed: {
    posts() {
      return this.$store.getters['saasLayout/getHighlighted'].slice(0, 3)
    },
  },
}
</script>
